function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
// Context 생성
export var SessionContext = /*#__PURE__*/ createContext(undefined);
/**
 * 세션 관리 Context Provider
 * 애플리케이션 전체에서 세션 상태를 공유합니다.
 */ export var SessionProvider = function(param) {
    var children = param.children, authServerUrl = param.authServerUrl, _param_autoStart = param.autoStart, autoStart = _param_autoStart === void 0 ? false : _param_autoStart, _param_checkFrequency = param.checkFrequency, checkFrequency = _param_checkFrequency === void 0 ? 10 * 60 * 1000 // 10분
     : _param_checkFrequency;
    // Inline session manager implementation to avoid circular dependency
    var _useState = _sliced_to_array(useState(null), 2), sessionStatus = _useState[0], setSessionStatus = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var startSession = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            setIsLoading(true);
            // Session management logic would go here
            setIsLoading(false);
            return [
                2
            ];
        });
    }), []);
    var stopSession = useCallback(function() {
        setSessionStatus(null);
    }, []);
    var getSessionManager = useCallback(function() {
        return {
            authServerUrl: authServerUrl,
            autoStart: autoStart,
            checkFrequency: checkFrequency
        };
    }, [
        authServerUrl,
        autoStart,
        checkFrequency
    ]);
    var sessionManagerData = {
        sessionStatus: sessionStatus,
        isLoading: isLoading,
        startSession: startSession,
        stopSession: stopSession,
        getSessionManager: getSessionManager
    };
    return /*#__PURE__*/ React.createElement(SessionContext.Provider, {
        value: sessionManagerData
    }, children);
};
/**
 * 세션 관리 Hook
 * 컴포넌트에서 세션 상태에 접근할 때 사용합니다.
 */ export var useSession = function() {
    var context = useContext(SessionContext);
    if (context === undefined) {
        throw new Error('useSession must be used within a SessionProvider');
    }
    return context;
};
/**
 * 세션 상태만 필요한 경우 사용하는 Hook
 */ export var useSessionStatus = function() {
    var _useSession = useSession(), sessionStatus = _useSession.sessionStatus, isLoading = _useSession.isLoading, error = _useSession.error;
    return {
        sessionStatus: sessionStatus,
        isLoading: isLoading,
        error: error
    };
};
/**
 * 세션 관리 액션만 필요한 경우 사용하는 Hook
 */ export var useSessionActions = function() {
    var _useSession = useSession(), checkSessionStatus = _useSession.checkSessionStatus, createSession = _useSession.createSession, startAutoManagement = _useSession.startAutoManagement, stopAutoManagement = _useSession.stopAutoManagement;
    return {
        checkSessionStatus: checkSessionStatus,
        createSession: createSession,
        startAutoManagement: startAutoManagement,
        stopAutoManagement: stopAutoManagement
    };
};
// 필요한 페이지에서만 수동 활성화
var SettingsPage = function() {
    var startAutoManagement = useSession().startAutoManagement;
    useEffect(function() {
        // 설정 페이지에서만 세션 관리 시작
        startAutoManagement();
    }, []);
};
